/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateTemporalClosureRequestProductsInner } from './CreateTemporalClosureRequestProductsInner';
import {
    CreateTemporalClosureRequestProductsInnerFromJSON,
    CreateTemporalClosureRequestProductsInnerFromJSONTyped,
    CreateTemporalClosureRequestProductsInnerToJSON,
    CreateTemporalClosureRequestProductsInnerToJSONTyped,
} from './CreateTemporalClosureRequestProductsInner';

/**
 * 
 * @export
 * @interface CreateTemporalClosureRequest
 */
export interface CreateTemporalClosureRequest {
    /**
     * 
     * @type {Date}
     * @memberof CreateTemporalClosureRequest
     */
    from: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateTemporalClosureRequest
     */
    to: Date;
    /**
     * 
     * @type {string}
     * @memberof CreateTemporalClosureRequest
     */
    reason?: string;
    /**
     * 
     * @type {Array<CreateTemporalClosureRequestProductsInner>}
     * @memberof CreateTemporalClosureRequest
     */
    products: Array<CreateTemporalClosureRequestProductsInner>;
}

/**
 * Check if a given object implements the CreateTemporalClosureRequest interface.
 */
export function instanceOfCreateTemporalClosureRequest(value: object): value is CreateTemporalClosureRequest {
    if (!('from' in value) || value['from'] === undefined) return false;
    if (!('to' in value) || value['to'] === undefined) return false;
    if (!('products' in value) || value['products'] === undefined) return false;
    return true;
}

export function CreateTemporalClosureRequestFromJSON(json: any): CreateTemporalClosureRequest {
    return CreateTemporalClosureRequestFromJSONTyped(json, false);
}

export function CreateTemporalClosureRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTemporalClosureRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'from': (new Date(json['from'])),
        'to': (new Date(json['to'])),
        'reason': json['reason'] == null ? undefined : json['reason'],
        'products': ((json['products'] as Array<any>).map(CreateTemporalClosureRequestProductsInnerFromJSON)),
    };
}

export function CreateTemporalClosureRequestToJSON(json: any): CreateTemporalClosureRequest {
    return CreateTemporalClosureRequestToJSONTyped(json, false);
}

export function CreateTemporalClosureRequestToJSONTyped(value?: CreateTemporalClosureRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'from': ((value['from']).toISOString()),
        'to': ((value['to']).toISOString()),
        'reason': value['reason'],
        'products': ((value['products'] as Array<any>).map(CreateTemporalClosureRequestProductsInnerToJSON)),
    };
}

